import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTheme } from '../../actions/layoutActions';
import { Helmet } from 'react-helmet';


class RouterUpdate extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    setTheme: PropTypes.func.isRequired
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
    this.props.setTheme('DEFAULT');
    document.body.classList.remove('disable-scroll');
  }

  render() {
    return (
      <Helmet>
        <title>Berki Melinda</title>
      </Helmet>
    );
  }
}


const mapDispatchToProps = {
  setTheme
};


export default withRouter(connect(null, mapDispatchToProps)(RouterUpdate));


// WEBPACK FOOTER //
// ./src/components/common/RouterUpdate.js